'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _auroraJavascriptUtils = require('@unitedtraders/aurora-javascript-utils');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * convert Role enum to string representation if required
 */
var normalizeRole = function normalizeRole(role) {
    return role.name ? _auroraJavascriptUtils.assert.string(role.name) : _auroraJavascriptUtils.assert.string(role);
};

/**
 * convert Role enum to string representation if required
 */
var normalizeRoles = function normalizeRoles(requiredRoles) {
    return requiredRoles.map(normalizeRole);
};

var AbstractAuthorization = function () {
    function AbstractAuthorization() {
        _classCallCheck(this, AbstractAuthorization);

        if (this.constructor === AbstractAuthorization) {
            throw new TypeError('Can not construct abstract class.');
        }
    }

    _createClass(AbstractAuthorization, [{
        key: 'hasRole',
        value: function hasRole(role) {
            var roles = this.getRoles() || [];
            return roles.includes(normalizeRole(role));
        }
    }, {
        key: 'hasAnyRole',
        value: function hasAnyRole(rolesToCheck) {
            var roles = this.getRoles() || [];
            return normalizeRoles(rolesToCheck).some(function (role) {
                return roles.includes(role);
            });
        }
    }, {
        key: 'getRoles',
        value: function getRoles() {
            throw new Error('not implemented');
        }
    }, {
        key: 'logout',
        value: function logout() {
            throw new Error('not implemented');
        }
    }, {
        key: 'getAuthorizationPromise',
        value: function getAuthorizationPromise() {
            throw new Error('not implemented');
        }
    }, {
        key: 'getUserInfo',
        value: function getUserInfo() {
            throw new Error('not implemented');
        }

        /**
         * return promise
         */

    }, {
        key: 'getAuthorizationHeaderValue',
        value: function getAuthorizationHeaderValue() {
            throw new Error('not implemented');
        }
    }]);

    return AbstractAuthorization;
}();

exports.default = AbstractAuthorization;


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/application-bootstrapper/dist/authorization/AbstractAuthorization.js
// module id = 1314
// module chunks = 118